import { useState } from 'react';
import { toaster } from 'evergreen-ui';
import { requestFerie, fetchFerieRequests, updateFerieRequestStatus } from '../../services/turniService';

const useFerie = ({ isDirector, userName, onFerieApproved }) => {
  const [managerFerieList, setManagerFerieList] = useState([]);
  const [ferieInputs, setFerieInputs] = useState({
    start_date: '',
    end_date: '',
    start_time: '',
    end_time: '',
    motivazione: '',
    operator_name: userName,
    type: 'Ferie',
    file: null,
  });

  const handleRequestFerie = async () => {
    try {
      const payload = { ...ferieInputs, is_director: isDirector };
      await requestFerie(payload);
      toaster.success(isDirector ? 'Richiesta assenza approvata inserita' : 'Richiesta inviata con successo');
      setFerieInputs({ start_date: '', end_date: '', start_time: '', end_time: '', motivazione: '', operator_name: userName, type: 'Ferie', file: null });
      if (onFerieApproved) onFerieApproved();
      return true;
    } catch (e) {
      toaster.danger('Errore: ' + e.message);
      return false;
    }
  };

  const handleOpenManagerFerie = async () => {
    try {
      const reqs = await fetchFerieRequests();
      setManagerFerieList(reqs || []);
      return reqs || [];
    } catch (e) {
      toaster.danger('Errore recupero richieste ferie: ' + e.message);
      return [];
    }
  };

  const handleOpenMyFerie = async () => {
    try {
      const reqs = await fetchFerieRequests();
      const myReqs = (reqs || []).filter(req => req.operator_name === userName);
      setManagerFerieList(myReqs);
      return myReqs;
    } catch (e) {
      toaster.danger('Errore recupero richieste ferie: ' + e.message);
      return [];
    }
  };

  const handleUpdateFerieStatus = async (id, newStatus) => {
    try {
      await updateFerieRequestStatus(id, newStatus);
      toaster.success(`Ferie o permesso ${newStatus}!`);
      const reqs = await fetchFerieRequests();
      setManagerFerieList(reqs || []);
      if (newStatus === 'approvata' && onFerieApproved) onFerieApproved();
    } catch (e) {
      toaster.danger('Errore durante aggiornamento ferie: ' + e.message);
    }
  };

  return {
    managerFerieList,
    setManagerFerieList,
    ferieInputs,
    setFerieInputs,
    handleRequestFerie,
    handleOpenManagerFerie,
    handleOpenMyFerie,
    handleUpdateFerieStatus,
  };
};

export default useFerie;
